import type { ReactNode } from "react";

type AuthLayoutProps = { children: ReactNode; className?: string };

export function AuthLayout({ children, className }: AuthLayoutProps) {
  return (
    <div className={["auth-layout", className].filter(Boolean).join(" ")}>{children}</div>
  );
}
